import { useEffect, useMemo } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Dialog, DialogContent, Box, Typography, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

export function EngagementLanding({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ position: "absolute", right: 8, top: 8 }}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 4 }}>
        <CheckCircleIcon sx={{ color: "success.main", fontSize: 40, mb: 1 }} />
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5 }}>
          Thanks! We’ve received your request.
        </Typography>
        <Typography variant="body1">Your account manager will be in touch shortly.</Typography>
      </DialogContent>
    </Dialog>
  );
}

export default function EngagementLandingRoute() {
  const location = useLocation();
  const history = useHistory();

  const source = useMemo(() => {
    const sp = new URLSearchParams(location.search || "");
    return sp.get("source") || "engagementRoute";
  }, [location.search]);

  useEffect(() => {
    const post = async () => {
      try {
        const storedUser = localStorage.getItem("user");
        const accessToken = storedUser ? JSON.parse(storedUser)?.accessToken : undefined;
        if (!accessToken) {
          //Must click again when signed in
          history.replace("/");
          return;
        }
        await fetch("/api/salesforce/engagements", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ source }),
        });
        sessionStorage.setItem("showQuoteModal", "1");
      } catch (e) {
        // Non-blocking
      } finally {
        history.replace("/");
      }
    };
    post();
  }, []);

  return null;
}
